/**
 * Class used to store configuration of the 3MF Serializer
 */
export class ThreeMfSerializerGlobalConfiguration {
    /**
     * Url to use to load the fflate library (for zip compression)
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static FFLATEUrl = "https://unpkg.com/fflate@0.8.2";
}
